import { Input, Select, Button, message } from "antd";
import Swal from "sweetalert2";
import {
  createTagFieldApi,
  createTagGroupApi,
  getTagGroupNameApi,
} from "../../../../apiservice/setting";
import { useEffect, useState } from "react";

const { Option } = Select;

const TagCreateForm = ({ authInfo, onSuccess }) => {
  const [groups, setGroups] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [groupId, setGroupId] = useState(null);
  const [tagName, setTagName] = useState("");
  const [groupCreated, setGroupCreated] = useState(false);


  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    const res = await getTagGroupNameApi({
      branch_id: authInfo.userInfo.branch_id,
      institution_id: authInfo.id,
    });
    setGroups(res.data.data || []);
  };

  const createGroup = async () => {
  if (!groupName.trim()) return;

  const res = await createTagGroupApi({
    branch_id: authInfo.userInfo.branch_id,
    institution_id: authInfo.id,
    groupname: groupName,
  });

  if (!res.data.error) {
    setGroupName("");
    setGroupCreated(true); // ✅ show message
    loadGroups();

    setTimeout(() => {
      setGroupCreated(false);
    }, 3000); // auto-hide after 3 sec
  }
  };


  const createTag = async () => {
    if (!groupId || !tagName.trim()) {
      Swal.fire("All fields required", "", "warning");
      return;
    }
    
  const res = await createTagFieldApi({
    tagid: groupId,
    branch_id: authInfo.userInfo.branch_id,
    field_name: tagName.trim(),
    action: "create",
  });

      if (!res.data.error) {
        message.success("Tag created");

        onSuccess?.({
          groupId,
          createdName: tagName.trim(), // ✅ MUST match parent
        });
      }

    
  };

  return (
    <>
      <Input
        placeholder="New Tag Group"
        value={groupName}
        onChange={(e) => setGroupName(e.target.value)}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Button onClick={createGroup}>+ Create Group</Button>

        {groupCreated && (
          <span style={{ color: "#52c41a", fontSize: 12 }}>
            Tag Group created successfully
          </span>
        )}
      </div>

      <Select
        style={{ width: "100%", marginBottom: 8 }}
        placeholder="Select Group"
        value={groupId}
        onChange={setGroupId}
      >
        {groups.map((g) => (
          <Option key={g.id} value={g.id}>
            {g.group_name}
          </Option>
        ))}
      </Select>

      <Input
        placeholder="Tag Name"
        value={tagName}
        onChange={(e) => setTagName(e.target.value)}
      />

      <Button type="primary" block onClick={createTag} style={{ marginTop: 12 }}>
        Save Tag
      </Button>
    </>
  );
};

export default TagCreateForm;
